import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Paperclip } from "lucide-react";
import { toast } from "sonner";
import { api, safe } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function AttachToLoan({ study }) {
  const { tasks, persona } = useApp();
  const loans = (tasks || []).filter((t) => t.type === "loan");
  const [tid, setTid] = useState(study.attached_to || study.task_id || "");
  const [cur, setCur] = useState(null);
  const pick = tid || loans[0]?.id || "";
  const load = useCallback(() => { if (pick) api.get(`/tasks/${pick}`).then((r) => setCur(r.data)); }, [pick]);
  useEffect(() => { load(); }, [load]);
  const attach = safe(async () => {
    const r = await api.post(`/market-comps/studies/${study.id}/attach`, { task_id: pick });
    toast.success(r.data.memo_updated ? "Attached - the memo's Market Comparables section was updated" : "Attached - it will be added when the memo is drafted"); load();
  });
  const detach = safe(async () => { await api.delete(`/market-comps/studies/${study.id}/attach/${pick}`); toast.success("Detached and removed from the memo"); load(); });
  if (!loans.length || !persona?.permissions.includes("lending.edit")) return null;
  const attached = cur?.comp_study_id === study.id;
  return (
    <div className="panel p-4 flex flex-wrap gap-3 items-center justify-between" data-testid="attach-to-loan">
      <div><div className="text-sm font-semibold text-slate-900 flex items-center gap-1.5"><Paperclip className="w-3.5 h-3.5" />Use in a credit memo</div>
        <div className="text-[11px] text-slate-500">Attaching adds the chosen comps, adjustments, indicated value and market rent to the loan's memo and Credit Committee Pack. The section is generated from this study, not written by AI.</div>
        {cur?.comp_study_id && <div className="text-[11px] mt-1" data-testid="attach-status">{attached ? <span className="text-emerald-700 font-semibold">Attached to {cur.title}</span> : <span className="text-amber-700">This loan uses study {cur.comp_study_id}; attaching replaces it</span>} · <Link to={`/task/${pick}`} className="text-sky-700 underline">open loan</Link></div>}</div>
      <div className="flex gap-2">
        <select data-testid="attach-loan-select" value={pick} onChange={(e) => setTid(e.target.value)} className="text-xs border border-slate-200 rounded-lg px-2 py-1.5">{loans.map((l) => <option key={l.id} value={l.id}>{l.title}</option>)}</select>
        {attached ? <button data-testid="detach-study" onClick={detach} className="btn-ghost">Detach</button> : <button data-testid="attach-study" onClick={attach} className="btn-primary">Attach to loan</button>}
      </div>
    </div>
  );
}
